<template>
    <div>
        <div class="topic-label">
            <span class="label-type">{{ setQuestionType(item) }}</span>
            <div class="label-tit">{{ item.questionContent }}</div>
        </div>
        <!--多选K型题的-->
        <div class="label-num" v-if="item.questionType==11">
            <span v-for="(list,num) in item.optionNumberList " :key="num">{{ list }}</span>
        </div>
        <el-radio-group v-model="answer" class="option-group" :disabled="submitted" v-removeAriaHidden>
            <div class="option-row" v-for="(opt, optIndex) in item.optionMapList" :key="'r-' + optIndex">
                <el-radio :label="opt.value">{{ opt.label }}</el-radio>
            </div>
        </el-radio-group>
        <div class="item-answer" v-if="!item.submitted">
            <el-button type="primary" @click="submit(item)"  :disabled="submitted">查看答案</el-button>
        </div>
    </div>
    
</template>

<script> 
import { getQuestionTypeLabel } from './topicQuestionTypes.js';
export default {
    name: 'TopicAnswerSingle',
    props: {
        item: { 
            type: Object,  
            required: true
         },
    },
    data(){
        return {
            answer:'',
            submitted:false,
        }
    },
    mounted(){
        //判断题单独处理
        if(this.item.questionType==3){
            this.item.optionMapList=[
                {value:'对',label:'对'},
                {value:'错',label:'错'},
            ];
        }
        // console.log(this.item,'=item')

    },
    methods: {
        setQuestionType: getQuestionTypeLabel, 
        submit(){
            if(this.answer==''){
                this.$message.warning('请选择答案～');
                return;
            }
            let params={
                id:this.item.id,
                answer:this.answer,
                questionFlag:'',
            }
            this.submitted=true;
            this.$emit('submitAnswer',params)
                // confirmAnswer(params).then(res=>{
                //     let {code,data,msg}=res.data;
                // })
        }
    },
};
</script>

<style lang="less" scoped>
@import './topic-info.less';
</style>
